/* global dataLayer */
/* eslint-disable max-lines-per-function */
import "./line-item-favorite-icon.scss";

import { api } from "jiffy-api";
import { sendDataLayer, track } from "jiffy-analytics";

export default () => {
  const icons = document.querySelectorAll(".js-line-item-favorite-icon:not(.initialized)");
  let favoriteAddedItems = [];
  const clearButtons = (favoriteCompositionId, businessLineId) => {
    document
      .querySelectorAll(
        `.js-line-item-favorite-icon[data-favorite-composition-id="${favoriteCompositionId}"][data-business-line-id="${businessLineId}"]`
      )
      .forEach(icon => {
        icon.classList.remove("line-item-favorite-icon--added");
      });
  };

  const fillButtons = (favoriteCompositionId, businessLineId) => {
    document
      .querySelectorAll(
        `.js-line-item-favorite-icon[data-favorite-composition-id="${favoriteCompositionId}"][data-business-line-id="${businessLineId}"]`
      )
      .forEach(icon => {
        icon.classList.add("line-item-favorite-icon--added");
      });
  };

  icons.forEach(icon => {
    const {
      favoriteColor,
      favoriteCompositionId,
      productId,
      productStyle,
      isFavorited,
      brand,
      productName,
      compositionInventoryRank,
      shippingRule,
      adwordsCategory,
      buttonDisplayType,
      businessLine,
      businessLineId
    } = icon.dataset;
    if (isFavorited === "true") {
      favoriteAddedItems = [...favoriteAddedItems, `${favoriteCompositionId}-${businessLineId}`];
    }

    icon.classList.add("initialized");

    const trackFavorited = event => {
      track(event, {
        brand,
        product: productName,
        composition: favoriteColor,
        spree_composition_id: favoriteCompositionId,
        composition_inventory_rank: compositionInventoryRank,
        fulfillment_group: shippingRule,
        product_category: adwordsCategory,
        source: buttonDisplayType,
        version: 2,
        business_line: businessLine
      });
    };

    const addToFavorites = async () => {
      try {
        await api.favorites.addFavoriteItem({
          product_slug: productId,
          ac: favoriteColor,
          business_line_id: businessLineId
        });

        fillButtons(favoriteCompositionId, businessLineId);
        favoriteAddedItems = [...favoriteAddedItems, `${favoriteCompositionId}-${businessLineId}`];
        dataLayer.push({ event: "AddToWishlist" });
        trackFavorited("product_favorited");
      } finally {
        icon.disabled = false;
      }
    };

    const removeFromFavorites = async () => {
      try {
        await api.favorites.removeFavoriteItem(
          { ac: encodeURIComponent(favoriteColor) },
          {
            product_slug: productId,
            business_line_id: businessLineId
          }
        );

        clearButtons(favoriteCompositionId, businessLineId);
        favoriteAddedItems = favoriteAddedItems.filter(
          item => item !== `${favoriteCompositionId}-${businessLineId}`
        );
        trackFavorited("product_unfavorited");
      } finally {
        icon.disabled = false;
      }
    };

    const onButtonClick = () => {
      icon.disabled = true;

      if (favoriteAddedItems.includes(`${favoriteCompositionId}-${businessLineId}`)) {
        removeFromFavorites();
        sendDataLayer({
          genericEvent: true,
          eventCategory: "Favorites",
          event: "Remove",
          eventLabel: `removefavoritePDP:${productStyle}:${favoriteColor}`
        });
      } else {
        addToFavorites();
        sendDataLayer({
          genericEvent: true,
          eventCategory: "Favorites",
          event: "AddFavorite",
          eventLabel: `favorite:${productStyle}:${favoriteColor}`
        });
      }
    };

    icon.addEventListener("click", onButtonClick);
  });
};
